import React from "react";
import { Box, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LockResetIcon from "@mui/icons-material/LockReset";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"; // NEW

const UserActions = ({
  user,
  onEdit,
  onDeactivate,
  onActivate,
  onResetPassword,
  onDelete, // NEW
}) => {
  return (
    <Box sx={{ display: "flex", gap: 1 }}>
      {/* Edit Button */}
      <Button
        variant="outlined"
        size="small"
        color="primary"
        onClick={() => onEdit(user)}
        sx={{ minWidth: "40px", padding: "6px", borderRadius: "50%" }}
      >
        <EditIcon />
      </Button>
    

      {/* Reset Password */}
      <Button
        variant="outlined"
        size="small"
        color="secondary"
        onClick={() => onResetPassword(user.Username)}
        sx={{ minWidth: "40px", padding: "6px", borderRadius: "50%" }}
      >
        <LockResetIcon />
      </Button>

      {/* Hard Delete (NEW) */}
      <Button
        variant="outlined"
        size="small"
        color="error"
        onClick={() => onDelete(user.Username)}
        sx={{ minWidth: "40px", padding: "6px", borderRadius: "50%" }}
      >
        <DeleteForeverIcon />
      </Button>
    </Box>
  );
};

export default UserActions;
